import { TooltipLabel } from "../../../../../ui/tooltip/label.js";
import { TooltipShortcut } from "../../../../../ui/tooltip/shortcut.js";
import { TooltipPopup } from "../../../../../ui/tooltip/popup.js";
import { TooltipRoot } from "../../../../../ui/tooltip/root.js";
import { TooltipTrigger } from "../../../../../ui/tooltip/trigger.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { cn } from "@videojs/utils/style";
//#region src/internal/skins/shared/components/buttons/button-tooltip.tsx
/** @jsxImportSource react */
function ButtonTooltip({ children, label, ...props }) {
	return /* @__PURE__ */ jsxs(TooltipRoot, {
		...props,
		children: [/* @__PURE__ */ jsx(TooltipTrigger, { render: children }), /* @__PURE__ */ jsxs(TooltipPopup, {
			className: cn("media-popup", "media-popup-safe-area", "media-popup-transition", "media-popup-surface", "media-tooltip"),
			children: [label ?? /* @__PURE__ */ jsx(TooltipLabel, {}), !label && /* @__PURE__ */ jsx(TooltipShortcut, { className: "media-tooltip-shortcut" })]
		})]
	});
}
//#endregion
export { ButtonTooltip };

//# sourceMappingURL=button-tooltip.js.map